import { ACTIONS_FROM_SM, REDUCERS } from '../../constants.js';

const initialActionFromSM = {
  reducer_type: REDUCERS.REDUCER_ACTIOS_FROM_SM,
  actionType: ACTIONS_FROM_SM.NO_ACTION,
  callType: 0,
  message: null,
  errorCode: null
};

const stateMachineActions = (state = initialActionFromSM, action) => {
  state = initialActionFromSM;
  switch (action.type) {
    case ACTIONS_FROM_SM.CALL_TYPE:
      return { actionType: ACTIONS_FROM_SM.CALL_TYPE, callType: action.callType, errorCode: null };
    case ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR:
      return { actionType: ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR, callType: state.callType, message: action.message, supervisor: action.supervisor };
    case ACTIONS_FROM_SM.LOGOUT:
      return { actionType: ACTIONS_FROM_SM.LOGED_OUT, callType: state.callType };
    case ACTIONS_FROM_SM.NO_AVAILABLE_INFO:
      return { actionType: ACTIONS_FROM_SM.NO_AVAILABLE_INFO, message: action.message };
    default:
      return state;
  }
}
export default stateMachineActions;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_actions_from_SM.js